import { addLogoToPdf } from "helpers";
import { jsPDF as JsPDF } from "jspdf";

import { Driver, DriverContact } from "../../drivers.types";
import { getFonts } from "./getFonts";
import { renderContacts } from "./renderContacts";
import { renderTitles } from "./renderTitles";

export const downloadDriverContacts = (
  driver: Driver,
  driverContacts: DriverContact[],
  date: string
) => {
  const pdf = new JsPDF({
    unit: "px"
  });

  addLogoToPdf(pdf);

  const { normalFontSize, normalFontStyles, bigFontSize } = getFonts();
  pdf.setLineHeightFactor(1.3);

  renderTitles({
    pdf,
    normalFontSize,
    bigFontSize,
    driver,
    date
  });

  renderContacts({ pdf, driverContacts, normalFontStyles });

  pdf.save(`driverContacts-${driver.id}.pdf`);
};
